export default __webpack_public_path__ + "static/media/mobile-sides.95bfee6c.png";